import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchShopList = ({commit}) => {

    axios.get('/shop/index.php', accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setShopList', res.data.response)         
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const loadStoreAddress = ({commit}, payload) => {

    axios.post('/shop/loadStoreAddress.php', {id: payload.id}, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(res.data.status) {
            commit(payload.target_commit, res.data.response)         
        }        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchShopData = ({commit, dispatch}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/shop/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            if(payload.copy) {
                res.data.response.id = 0
                commit('displaySuccessNotification', {message: 'Data copied!!!'});                
            }
            
            commit('setShopData', {response: res.data.response, copy: payload.copy})   
            dispatch('fetchDocumentList', {store_id: payload.id, copy: payload.copy})     
            
            dispatch('loadProvinceList', res.data.response.country_id)
            dispatch('loadCityList', res.data.response.province_id)
            
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }

        } else {
            commit('resetShopData')
        }
        dispatch('fetchTaxSetting')

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitShopData = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/shop/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            if(payload.id === 0) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            }
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error'})
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteShopData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/shop/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchShopList')
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/shop/actions.js